// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2024 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import GetPagedAzureProjectsListRequestModel from '../../model/get-paged-azure-projects-list-request-model';
import GetPagedAzureProjectsListRequestDTO from '../dto/get-paged-azure-projects-list-request-dto';
import dtoSchema from '../schemas/get-paged-azure-projects-list-request-schema';

export default abstract class GetPagedAzureProjectsListRequestModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<GetPagedAzureProjectsListRequestDTO>) {
    super();
    this.paging = {};
    if (data) {
      this.paging = {
        currentPage: data['paging.CurrentPage'],
        pageSize: data['paging.PageSize'],
        includeCount: data['paging.IncludeCount'],
        noPaging: data['paging.NoPaging'],
      };
      this.searchCriteria = data.searchCriteria;
    }
  }

  paging: {
    /**
    * @type {int32}
    */
    currentPage?: number;
    /**
    * @type {int32}
    */
    pageSize?: number;
    /**
    */
    includeCount?: boolean;
    /**
    */
    noPaging?: boolean;
  };

  /**
  */
  searchCriteria?: string;

  static toModel(dto: DeepPartial<GetPagedAzureProjectsListRequestDTO>): GetPagedAzureProjectsListRequestModel;
  static toModel(dto: DeepPartial<GetPagedAzureProjectsListRequestDTO> | undefined | null): GetPagedAzureProjectsListRequestModel | undefined;
  static toModel(dto: DeepPartial<GetPagedAzureProjectsListRequestDTO> | undefined | null): GetPagedAzureProjectsListRequestModel | undefined {
    return dto ? new GetPagedAzureProjectsListRequestModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<GetPagedAzureProjectsListRequestModel> | GetPagedAzureProjectsListRequestModel): GetPagedAzureProjectsListRequestDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      'paging.CurrentPage': unwrapped.paging?.currentPage,
      'paging.PageSize': unwrapped.paging?.pageSize,
      'paging.IncludeCount': unwrapped.paging?.includeCount,
      'paging.NoPaging': unwrapped.paging?.noPaging,
      searchCriteria: unwrapped.searchCriteria,
    } as GetPagedAzureProjectsListRequestDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for GetPagedAzureProjectsListRequestModel, can not map to GetPagedAzureProjectsListRequestDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
